export enum WorkingMode {
    UNDEFINED = 'UNDEFINED',
    CLOUD_SCHEDULE = 'CLOUD_SCHEDULE',
    USER_SCHEDULE = 'USER_SCHEDULE',
    HUB_REMOTE = 'HUB_REMOTE',
    CUSTOM_REMOTE = 'CUSTOM_REMOTE',
    REMOTE = 'REMOTE',
}
